{{#each buttons}}
  <button {{#if id}}id="{{id}}"{{/if}}{{#if class}} class="{{class}}"{{/if}} {{#if disabled}}disabled{{/if}} role="button" {{attributes}}>
    {{#if text}}
      {{t text}}
    {{/if}}
    {{#if blocks}}
      <div data-region="{{../cid}}-buttons-{{@index}}-blocks"></div>
    {{/if}}
  </button>
{{/each}}
